module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gs2uo"))).then(() => parcelRequire('d0iPb'));